import { render } from "./RecepcionEquipoList.vue?vue&type=template&id=a9dd304e&scoped=true"
import script from "./RecepcionEquipoList.vue?vue&type=script&lang=js"
export * from "./RecepcionEquipoList.vue?vue&type=script&lang=js"

import "./RecepcionEquipoList.vue?vue&type=style&index=0&id=a9dd304e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9dd304e"]])

export default __exports__